import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MainImageService {
  shouldMakeGemstoneSectionActive = false;
  getSnapshot?: () => Promise<string>;
}
